import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Megaphone, X } from "lucide-react";

export default function AnnouncementBar() {
  const [a, setA] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/messages/latest-broadcast");
        if (!alive) return;
        const ann = data.announcement;
        if (ann && localStorage.getItem(`imeak_ann_dismissed_${ann.id}`) === "1") setA(null);
        else setA(ann);
      } catch { /* ignore */ }
    };
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!a) return null;
  const when = new Date(a.created_at).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" });
  return (
    <div className="flex items-start gap-2.5 px-4 py-2.5 bg-[#0F2C59] text-white border-b border-cyan-900" data-testid="announcement-bar">
      <Megaphone className="h-4 w-4 mt-0.5 shrink-0 text-amber-300" />
      <p className="text-xs md:text-sm flex-1 leading-snug">
        <b className="text-amber-300">Duyuru</b> · {a.text}
        <span className="opacity-60 ml-2 text-[11px]">{a.sender_name} · {when}</span>
      </p>
      <button
        onClick={() => { localStorage.setItem(`imeak_ann_dismissed_${a.id}`, "1"); setA(null); }}
        className="p-1 rounded hover:bg-white/10 transition-colors"
        aria-label="Duyuruyu kapat"
        data-testid="announcement-close"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
